import React from "react";

const About = () => {
  return (
    <div className="w-full bg-white text-black">
      {/* Seção de Introdução */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold">Sobre Nós</h1>
          <p className="mt-4 text-lg text-gray-800">Conheça a história do nosso escritório e nossa missão em oferecer justiça e excelência.</p>
        </div>
      </div>

      {/* História Fictícia */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Nossa História</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto">
            <p className="text-gray-700 text-lg text-center">
              Fundado em 1998 pelo renomado advogado fictício Dr. João Silva, o Escritório de Advocacia Silva & Associados
              nasceu com a missão de oferecer serviços jurídicos de excelência e acessíveis a toda a comunidade. Com mais de
              25 anos de atuação, conquistamos a confiança de nossos clientes através de um atendimento humanizado e soluções
              eficazes para cada caso.
            </p>
            <p className="mt-4 text-gray-700 text-lg text-center">
              Nossa equipe é composta por especialistas altamente qualificados em diversas áreas do direito, garantindo suporte
              completo e comprometido com a defesa dos interesses de nossos clientes.
            </p>
          </div>
        </div>
      </div>

      {/* Localização Fictícia */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Nossa Localização</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto text-center">
            <p className="text-lg text-gray-700">
              Nosso escritório está localizado no coração da cidade de São Juridico-SP, no seguinte endereço:
            </p>
            <p className="font-bold text-gray-900 mt-2 text-xl">Av. Justiça Suprema, 1234 - Centro, São Juridico - SP, 01000-000</p>
            <p className="text-gray-700 text-lg">Estamos sempre prontos para atendê-lo. Venha tomar um café conosco!</p>
          </div>
        </div>
      </div>

      {/* Google Maps Embed (Localização Fictícia) */}
      <div className="w-full mt-6">
        <iframe
          title="Localização Escritório"
          className="w-full h-96"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345093646!2d144.96305781531883!3d-37.81627977975195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d5df1f2d3f7%3A0xf4cba48e4f85e66c!2sSupreme%20Court%20of%20Victoria!5e0!3m2!1sen!2sbr!4v1626336672280!5m2!1sen!2sbr"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default About;